import i18n from "i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import { initReactI18next } from "react-i18next";
import { messages } from "./languages";

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    debug: false,

    resources: messages,

    // namespaces
    ns: ["translations"],
    defaultNS: "translations",

    // idioma padrão caso não detecte
    fallbackLng: "pt",

    // recomendado pelo react-i18next (não precisa escapar)
    interpolation: { escapeValue: false },

    detection: {
      order: ["localStorage", "navigator", "htmlTag"],
      caches: ["localStorage"],
    },

    react: { useSuspense: false },
  });

export default i18n;